// |--------------------------------------------------------------------------
// |account アカウント画面
// |--------------------------------------------------------------------------
// |
// | ここではアカウントのapiを例として記述しています。
// | アカウントで使用するapiを全て記述します。
// | このapiを親のjs（functionApi.js）でimportして使用します。

/* ---------------------------------------------------------------------------
  一覧取得
---------------------------------------------------------------------------- */
export const list = async id => {
	return await axios.get(`/api/support_log`, {
		params: { company_id: id }
	});
};
/* ---------------------------------------------------------------------------
  詳細取得
---------------------------------------------------------------------------- */
export const show = async id => {
	return await axios.get(`/api/support_log/${id}`);
};

/* ---------------------------------------------------------------------------
  登録
---------------------------------------------------------------------------- */
// 通常の登録
export const store = async (id, data) => {
	return await axios.post(`/api/support_log/${id}`, data);
};
/* ---------------------------------------------------------------------------
  更新
---------------------------------------------------------------------------- */
// export const update = async (id, data) => {
// 	return await axios.patch(`/api/support_log/${id}`, data);
// };
/* ---------------------------------------------------------------------------
  削除
---------------------------------------------------------------------------- */
export const destroy = async id => {
	return await axios.delete(`/api/support_log/${id}`);
};
